import api from '@/lib/api';
import type {
  ApiResponse,
  HubFeedResponse,
  HubFeedQuery,
  HubWidgetSnapshot,
  HubWidgetQuery,
  HubEmsState,
  HubInteraction,
  HubInteractionRequest,
  HubEmsActivateRequest,
  HubEmsDeactivateRequest,
  PaginationMeta,
} from '@amuster/types';

export const hubService = {
  getFeed(query?: HubFeedQuery) {
    return api.get<ApiResponse<HubFeedResponse> & { meta: PaginationMeta }>(
      '/hub/feed',
      { params: query },
    );
  },

  getWidgets(query?: HubWidgetQuery) {
    return api.get<ApiResponse<HubWidgetSnapshot[]>>('/hub/widgets', {
      params: query,
    });
  },

  getEmsState(campusId: string) {
    return api.get<ApiResponse<HubEmsState>>(`/hub/ems/${campusId}`);
  },

  createInteraction(data: HubInteractionRequest) {
    return api.post<ApiResponse<HubInteraction>>('/hub/interactions', data);
  },

  activateEms(data: HubEmsActivateRequest) {
    return api.post<ApiResponse<HubEmsState>>('/hub/ems/activate', data);
  },

  deactivateEms(data: HubEmsDeactivateRequest) {
    return api.post<ApiResponse<HubEmsState>>('/hub/ems/deactivate', data);
  },
};
